import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('whatsapp_content_templates', { accountScoped: true });
  }

  getAll(inboxId = null) {
    if (inboxId) {
      // eslint-disable-next-line no-undef
      return axios.get(`${this.url}?inbox_id=${inboxId}`);
    }
    return this.get();
  }

  getSingle(id) {
    return this.show(id);
  }

  createTemplate(data) {
    return this.create({ whatsapp_content_template: data });
  }

  updateTemplate(id, data) {
    return this.update(id, { whatsapp_content_template: data });
  }

  deleteTemplate(id) {
    return this.delete(id);
  }
}

export default new WhatsappTemplatesAPI();
